<template>
  <CChartLine
    :datasets="defaultDatasets"
    :options="defaultOptions"
    :labels="['January','February','March','April','May','June','July','August','September','October','November','December']"
    :monthdatasets="monthDatasets"
    :monthoptions="monthOptions"
    :monthlabels="['Jan','Feb','Mar','Apr','May','June','July','Aug','Sep','Oct','Nov','Dec']"
  />

  
  <!-- :labels="['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']" -->

</template>
<script>
import { CChartLine } from '@coreui/coreui-vue-chartjs'
import { getColor, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { lightblue, blue } from 'color-name'

export default {
  name: 'MemberOnlineChartYear',
  components: {
    CChartLine
  },
  computed: {
    defaultDatasets () {
      const brandDanger = getColor('danger') || '#f86c6b'
      const brandInfo = getColor('info') || '#20a8d8'
      const data1 = [7,10,15,10,15,20,40,50,70,40,20,15]
      const a = Math.max.apply(Math,this.data1)

      return [
        {
          label: 'Member Withdraw',
          backgroundColor: hexToRgba(brandDanger, 10),
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 2,
          data: data1
        }
      ]
    },
    defaultOptions () {
      return {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 10,
              stepSize: Math.ceil(this.a / 5),
              max: this.a
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
  
</script>



// WEBPACK FOOTER //
// src/components/Chart/MemberWithdrawChartYear.vue